import { useMemo } from 'react';
import { useAppSelector } from '../../../../../../redux/hooks';
import { cohortConfigTypeSelector } from '../../../../../../redux/selectors/builder';
import {
  FunnelCohortOperatorKey,
  SimpleCohortTypeKey,
} from '../../../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../../../utils/types';
import useAnalysisBuilderInfo from '../../../../../../redux/selectorHooks/useAnalysisBuilderInfo';
import { useCohortRowContext } from '../../CohortRowContext';
import { CohortRowOperatorMenu } from '../../CohortRowOperators';

const FunnelCohortOperators = () => {
  const { cohortRow } = useCohortRowContext();
  const { analysisId, simpleCohortTypeKey } = cohortRow;
  assertCondition(simpleCohortTypeKey === SimpleCohortTypeKey.Funnel);
  const cohortConfigSelector = useAppSelector((state) =>
    cohortConfigTypeSelector(state, simpleCohortTypeKey),
  );
  assertCondition(cohortConfigSelector.__typename === 'FunnelCohortConfig');
  const { operators } = cohortConfigSelector;
  const analysisBuilderInfo = useAnalysisBuilderInfo(analysisId);
  const builderInfo = analysisBuilderInfo?.query;
  const funnelOperators = useMemo(() => {
    if (!builderInfo) {
      // Until user select a funnel we allow to select only 'CONVERTED_ON'
      return operators.filter(
        (operator) => operator.key === FunnelCohortOperatorKey.ConvertedOn,
      );
    }

    return operators;
  }, [builderInfo, operators]);

  return <CohortRowOperatorMenu operators={funnelOperators} />;
};

export default FunnelCohortOperators;
